import * as Sentry from '@sentry/react';
import { version as appVersion } from 'client/package.json';
import ClientConfig from 'src/config/config.ts';

const sentryReplayConfig = {
  maskAllInputs: false,
  maskAllText: false,
  blockAllMedia: false,
};

const sentryIgnoreErrors = [
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications',
  'Network Error',
  'NetworkError when attempting to fetch resource',
  'Non-Error promise rejection captured',
];

const shouldCreateSpanForRequest = (url: string): boolean => {
  return !url.includes('zdassets.com') && !url.includes('zendesk.com');
};

const sentryConfig: Sentry.BrowserOptions = {
  dsn: 'https://ed3befc7ef8552b0a7546a0a14c63b2d@o324733.ingest.us.sentry.io/4507809132183552',
  release: `forecast-${appVersion}`,
  environment: ClientConfig.config.sentryEnvironment,

  ignoreErrors: sentryIgnoreErrors,

  tracesSampleRate: 0.5,
  tracePropagationTargets: [/^https:\/\/(.*\.)?oliasoft\.com/],

  // Do not record normal user sessions, only sessions where an error occurs.
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,

  integrations: [
    Sentry.browserTracingIntegration({
      shouldCreateSpanForRequest,
    }),
    Sentry.replayIntegration(sentryReplayConfig),
  ],
};

if (ClientConfig.config.enableSentry) {
  Sentry.init(sentryConfig);
}
